module.exports = __webpack_public_path__ + "/5cabcdd0ff0768c7ee4e3ff4d5ea9e93.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/api_icons/api_dashboard_icon.svg
 ** module id = 951
 ** module chunks = 0
 **/